"use strict";
/**
 * Supplier Payments Enums ("Próximos pagos a proveedores")
 *
 * Unifies the payment obligations a payer must settle each period across several
 * sources: QVET credit invoices (vencimientos), recurring monthly obligations,
 * and sporadic ad-hoc payments — plus generic per-supplier discount rules.
 *
 * See design doc: resources/research/20260701-supplier-payments-platform.md
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EARLY_PAYMENT_DISCOUNT_APPLICATION_LABELS = exports.EarlyPaymentDiscountApplication = exports.DEFAULT_PAY_DAY = exports.RECURRING_AMOUNT_TYPE_LABELS = exports.RecurringAmountType = exports.PAYMENT_STATUS_LABELS = exports.PaymentStatus = exports.PAYMENT_TYPE_LABELS = exports.PaymentType = void 0;
// --- Payment type (the source of the obligation) ---
/**
 * Where a payment obligation comes from.
 *
 * - `qvet_credit` (Crédito QVET): a supplier invoice paid by transfer that has a
 *   vencimiento (due date) in QVET report 718.
 * - `recurring`   (Recurrente): a known monthly obligation not in QVET
 *   (Petco, QVET, Medam, SAT, IMSS, Anilab, Yi Health, Península).
 * - `adhoc`       (Esporádico): a one-off payment captured manually.
 */
var PaymentType;
(function (PaymentType) {
    PaymentType["qvet_credit"] = "qvet_credit";
    PaymentType["recurring"] = "recurring";
    PaymentType["adhoc"] = "adhoc";
    PaymentType["discount"] = "discount";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
exports.PAYMENT_TYPE_LABELS = {
    [PaymentType.qvet_credit]: "Crédito QVET",
    [PaymentType.recurring]: "Recurrente",
    [PaymentType.adhoc]: "Esporádico",
    [PaymentType.discount]: "Descuento",
};
// --- Payment status ---
/**
 * Settlement status of a single payment obligation.
 *
 * - `pending`   (Pendiente): not yet paid.
 * - `paid`      (Pagado): settled.
 * - `scheduled` (Programado): planned for a future pay day but not yet paid.
 * - `cancelled` (Cancelado): no longer owed.
 */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["pending"] = "pending";
    PaymentStatus["paid"] = "paid";
    PaymentStatus["scheduled"] = "scheduled";
    PaymentStatus["cancelled"] = "cancelled";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
exports.PAYMENT_STATUS_LABELS = {
    [PaymentStatus.pending]: "Pendiente",
    [PaymentStatus.paid]: "Pagado",
    [PaymentStatus.scheduled]: "Programado",
    [PaymentStatus.cancelled]: "Cancelado",
};
// --- Recurring amount kind ---
/**
 * Whether a recurring payment has a fixed amount or a variable one entered each month.
 */
var RecurringAmountType;
(function (RecurringAmountType) {
    RecurringAmountType["fixed"] = "fixed";
    RecurringAmountType["variable"] = "variable";
})(RecurringAmountType || (exports.RecurringAmountType = RecurringAmountType = {}));
exports.RECURRING_AMOUNT_TYPE_LABELS = {
    [RecurringAmountType.fixed]: "Fijo",
    [RecurringAmountType.variable]: "Variable",
};
/** Default pay day (day of month) when a payment doesn't specify one. */
exports.DEFAULT_PAY_DAY = 1;
// --- Early payment discount (pronto pago) ---
/**
 * How a supplier's early payment discount reaches us. The discount is **conditional**: it only
 * applies when the invoice is paid within the supplier's deadline.
 *
 * - `on_invoice`  (En la factura): already deducted on the invoice lines (Difarvet).
 * - `credit_note` (Nota de crédito): invoiced at full price and refunded afterwards with a
 *   credit note (Telvet, monthly).
 * - `unknown` (Por confirmar): the percentage is confirmed but not how it arrives (Total Pets,
 *   2026-09-18). The cost engine still applies the percentage; only reconciliation needs the mechanism.
 */
var EarlyPaymentDiscountApplication;
(function (EarlyPaymentDiscountApplication) {
    EarlyPaymentDiscountApplication["on_invoice"] = "on_invoice";
    EarlyPaymentDiscountApplication["credit_note"] = "credit_note";
    EarlyPaymentDiscountApplication["unknown"] = "unknown";
})(EarlyPaymentDiscountApplication || (exports.EarlyPaymentDiscountApplication = EarlyPaymentDiscountApplication = {}));
exports.EARLY_PAYMENT_DISCOUNT_APPLICATION_LABELS = {
    [EarlyPaymentDiscountApplication.on_invoice]: "Descontado en la factura",
    [EarlyPaymentDiscountApplication.credit_note]: "Nota de crédito aparte",
    [EarlyPaymentDiscountApplication.unknown]: "Por confirmar",
};
